import * as redux from "utils/redux";
import * as actions from "./actions";

export const showToast = redux.action(actions.showToast);
export const hideToast = redux.action(actions.hideToast);
export const showModal = redux.action(actions.showModal);
export const hideModal = redux.action(actions.hideModal);
